import React, { useState, useEffect } from 'react';
import { Grid, Box, Button } from '@mui/material';
import StatCard from './StatCard';

const STORAGE_KEY = 'visibleStatsTitles';

const StatsGrid = ({ stats }) => {
  const [visibleStats, setVisibleStats] = useState(stats);


  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      const savedTitles = JSON.parse(saved);
      const filtered = stats.filter(stat => savedTitles.includes(stat.title));
      setVisibleStats(filtered.length ? filtered : stats);
    }
  }, [stats]);


  useEffect(() => {
    const titles = visibleStats.map(stat => stat.title);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(titles));
  }, [visibleStats]);

  const handleHide = (indexToRemove) => {
    setVisibleStats(prev => prev.filter((_, index) => index !== indexToRemove));
  };

  const handleReset = () => {
    setVisibleStats(stats);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(stats.map(stat => stat.title)));
  };

  const cardCount = visibleStats.length;
  const md = cardCount >= 4 ? 3 : cardCount === 3 ? 4 : cardCount === 2 ? 6 : 12;

  return (
    <Box>
      {cardCount < stats.length && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
          <Button onClick={handleReset} variant="outlined" size="small">
            Reset Cards
          </Button>
        </Box>
      )}
      <Grid container spacing={3}>
        {visibleStats.map((stat, index) => (
          <Grid item xs={12} md={md} key={index}>
            <StatCard {...stat} onHide={() => handleHide(index)} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default StatsGrid;
